import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import '@formatjs/intl-pluralrules/polyfill-locales';

import { LOCALISATION } from '@constants/localisation';
import messagesEn from '@localisation/en.json';
import messagesJa from '@localisation/ja.json';

export type ILanguageProviderProps =  {
  children?: any,
};

const messages = {
  en: messagesEn,
  ja: messagesJa,
};

function LanguageProvider(props: ILanguageProviderProps) {
  const { children } = props;
  const locale = LOCALISATION.DEFAULT_LOCALE;

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={messages[locale]}
    >
      {children}
    </IntlProvider>
  );
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default withConnect(LanguageProvider);
